/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupType } from './OrganizationGroupType';
import {
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeFromJSONTyped,
    OrganizationGroupTypeToJSON,
    OrganizationGroupTypeToJSONTyped,
} from './OrganizationGroupType';

/**
 * 
 * @export
 * @interface UserMigrationQueryPermissionResponse
 */
export interface UserMigrationQueryPermissionResponse {
    /**
     * 
     * @type {any}
     * @memberof UserMigrationQueryPermissionResponse
     */
    permissionId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryPermissionResponse
     */
    permissionName?: string | null;
    /**
     * 
     * @type {OrganizationGroupType}
     * @memberof UserMigrationQueryPermissionResponse
     */
    requiredOrganizationGroupType?: OrganizationGroupType;
}



/**
 * Check if a given object implements the UserMigrationQueryPermissionResponse interface.
 */
export function instanceOfUserMigrationQueryPermissionResponse(value: object): value is UserMigrationQueryPermissionResponse {
    return true;
}

export function UserMigrationQueryPermissionResponseFromJSON(json: any): UserMigrationQueryPermissionResponse {
    return UserMigrationQueryPermissionResponseFromJSONTyped(json, false);
}

export function UserMigrationQueryPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationQueryPermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionId': json['permissionId'] === undefined ? undefined : json['permissionId'] === null ? null : json['permissionId'],
        'permissionName': json['permissionName'] === undefined ? undefined : json['permissionName'] === null ? null : json['permissionName'],
        'requiredOrganizationGroupType': json['requiredOrganizationGroupType'] == null ? undefined : OrganizationGroupTypeFromJSON(json['requiredOrganizationGroupType']),
    };
}

export function UserMigrationQueryPermissionResponseToJSON(json: any): UserMigrationQueryPermissionResponse {
    return UserMigrationQueryPermissionResponseToJSONTyped(json, false);
}

export function UserMigrationQueryPermissionResponseToJSONTyped(value?: UserMigrationQueryPermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionId': value['permissionId'],
        'permissionName': value['permissionName'],
        'requiredOrganizationGroupType': OrganizationGroupTypeToJSON(value['requiredOrganizationGroupType']),
    };
}

